"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var div_icon_v2_component_1 = __importDefault(require("./div-icon-v2.component"));
var PinContainer = function (_a) {
    var location = _a.location, children = _a.children;
    return react_1.default.createElement(div_icon_v2_component_1.default, { position: { lat: location.latitude, lng: location.longitude } }, children);
};
exports.default = PinContainer;
